// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/javascripts/libraries_and_infrequently_changed.js
// MAGIC_DESPROCKET_END
// Helpers extracted from the jquery.form plugin when it was removed,
// because it was not trivial to prove they were unused
(function($) {
  /**
  * Enables or disables any matching elements.
  */
  $.fn.enable = function(b) {
      if (b == undefined) b = true;
      return this.each(function() {
          this.disabled = !b;
      });
  };

  /**
  * Checks/unchecks any matching checkboxes or radio buttons and
  * selects/deselects and matching option elements.
  */
  $.fn.selected = function(select) {
      if (select == undefined) select = true;
      return this.each(function() {
          var t = this.type;
          if (t == 'checkbox' || t == 'radio')
              this.checked = select;
          else if (this.tagName.toLowerCase() == 'option') {
              var $sel = $(this).parent('select');
              if (select && $sel[0] && $sel[0].type == 'select-one') {
                  // deselect all other options
                  $sel.find('option').selected(false);
              }
              this.selected = select;
          }
      });
  };
})(jQuery);
